<div (click)="onClick()" class="subscription-container"
  [class.is-free]="!isLoading && isOnlyDefaultPlan"
  [class.is-paid]="!isLoading && !isOnlyDefaultPlan"
  title="Manage subscriptions">
  <div class="subscription-display ps-2">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="subscription-icon">
      <path d="M3 20h18"></path>
      <path d="m3 10 4 4 5-8 5 8 4-4v8H3z"></path>
    </svg>
  </div>
  <ng-container *ngIf="!isLoading; else loading">
    <ng-container *ngIf="isOnlyDefaultPlan; else paidPlan">
      <span class="free-badge">BASIC</span>
      <i class="ti ti-arrow-up-circle upgrade-icon" title="Upgrade available"></i>
    </ng-container>
    <ng-template #paidPlan>
      <span class="subscription-count">{{ count }}</span>
      <span class="paid-badge">{{ count === 1 ? 'subscription' : 'subscriptions' }}</span>
      <i class="ti ti-shield-check active-icon" title="Active subscription"></i>
    </ng-template>
  </ng-container>
  <ng-template #loading>
    <span class="subscription-count">···</span>
  </ng-template>
</div>
